import React from 'react';
import PropTypes from 'prop-types';
import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import LedgerTag from '../lib/LedgerTag';
import LedgerEntryTypeTag from '../lib/LedgerEntryTypeTag';
import XIcon from '../lib/XIcon';
import { getAffectedTypeLabel, getAffectedTypeStyle } from '../common/Helpers';
import XBadge from '../lib/XBadge';


const TransactionGraph = (props) => {
  const { affectedNodes } = props;

  const nodes = affectedNodes.map((node) => {
    const keys = Object.keys(node);
    return ({...node[keys[0]], ...{AffectType: keys[0]}})
  })

  return (
    <div>
      <Card>
        <Card.Body>
          <Card.Title>
            <XIcon icon='hexagon-nodes' />
            <span className="ml-2">Affected Nodes</span>
          </Card.Title>

					<Table responsive>
						<thead>
							<tr className='text-nowrap'>
								<th className="text-left">#</th>
								<th className="text-left">Status</th>
								<th className="text-left">Ledger entry type</th>
								<th className="text-left">Object ID</th>
								<th className="text-left">Previous transaction</th>
							</tr>
						</thead>
						<tbody>

              {nodes.map((node, index) =>
                <tr key={index} className='text-nowrap'>
                  <td>{index+1}</td>
                  <td className='text-uppercase'>
                      <XBadge className={getAffectedTypeStyle(node.AffectType, 'table-')}>{getAffectedTypeLabel(node.AffectType)}</XBadge>
                  </td>
                  <td className="text-left">
                    <LedgerEntryTypeTag type={node["LedgerEntryType"]} />
                  </td>
                  <td className="text-left text-monospace">
                    <span className="address-tag address-tag-lg">
                      <Link to={`/object/${node["LedgerIndex"]}`}>{node["LedgerIndex"]}</Link>
                    </span>
                  </td>
                  <td className="text-left text-monospace">
                    <span className="address-tag mr-1">
                      <Link to={`/tx/${node["PreviousTxnID"]}`}>{node["PreviousTxnID"]}</Link>
                    </span>
                    {node["PreviousTxnLgrSeq"] &&
                      <LedgerTag ledger_index={node["PreviousTxnLgrSeq"]} />
                    }
                  </td>
                </tr>
              )}

						</tbody>
					</Table>

        </Card.Body>
      </Card>
    </div>
  );
}

TransactionGraph.defaultProps = {
  affectedNodes: [],
}

TransactionGraph.propTypes = {
  affectedNodes: PropTypes.array.isRequired,
}

export default TransactionGraph;
